









import {Vue, Component, Prop} from 'vue-property-decorator';

@Component({})
export default class LoadingIndicator extends Vue{
    @Prop({required: false}) message!: string;
    @Prop({required: false}) small!: boolean;
    @Prop({required: false}) center!: boolean;
    @Prop({required: false}) button!: boolean;
}
